module.exports = __webpack_public_path__ + "static/media/educacion.5fd2ba5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconos/educacion.png
// module id = 92
// module chunks = 0